export default __webpack_public_path__ + "static/media/sbj-physics.4f3ef9ad.svg";